import {connect} from 'react-redux';
import {Graphics as Component} from './Graphics';
import {
  setHeldObject,
  setSolutionHeld

} from '@learningblocks/protocol-redux/lib/Actions';

function mapStateToProps(state, ownProps) {
  return {
    id: ownProps.id,
    type: state.notebook.protocolSection.scene.apparatus.iceBuckets[ownProps.id-1].type,
    solutions: state.notebook.protocolSection.scene.apparatus.iceBuckets[ownProps.id-1].solutions,
    labelReactionTubes: state.notebook.protocolSection.scene.labelReactionTubes,
    interactionProps: {
      solutions: state.notebook.protocolSection.scene.apparatus.solutions
    }
  }
}

function mapDispatchToProps(dispatch) {
  return {
    setSolutionHeld: (data) => {
      dispatch(setSolutionHeld(data))
    },
    setHeldObject: (data) => {
      dispatch(setHeldObject(data))
    },
  };
}

export const Graphics = connect(
  mapStateToProps,
  mapDispatchToProps
)(Component);
